//import fetch from 'cross-fetch'

export const REQUEST_STORIES = 'REQUEST_STORIES'
export const RECEIVE_STORIES = 'RECEIVE_STORIES'
export const RESET_ACTIVE_STORY = 'RESET_ACTIVE_STORY'
export const RECEIVE_STORY = 'RECEIVE_STORY'
export const REQUEST_LIVE_STORY = 'REQUEST_LIVE_STORY'
export const RECEIVE_LIVE_STORY = 'RECEIVE_LIVE_STORY'
export const REQUEST_STORY = 'REQUEST_STORY'
export const INVALIDATE_STORIES = 'INVALIDATE_STORIES'
export const REQUEST_NEWS_SLIDES = 'REQUEST_NEWS_SLIDES'
export const RECEIVE_NEWS_SLIDES = 'RECEIVE_NEWS_SLIDES'
export const INVALIDATE_NEWS_SLIDES = 'INVALIDATE_NEWS_SLIDES'
export const REQUEST_ZEDLINES = 'REQUEST_ZEDLINES'
export const RECEIVE_ZEDLINES = 'RECEIVE_ZEDLINES'
export const INVALIDATE_ZEDLINES = 'INVALIDATE_ZEDLINES'
export const REQUEST_AUTHOR = 'REQUEST_AUTHOR'
export const RECEIVE_AUTHOR = 'RECEIVE_AUTHOR'

export function invalidateZedlines() {
  return {
    type: INVALIDATE_ZEDLINES
  }
}

function requestZedlines() {
  return {
    type: REQUEST_ZEDLINES
  }
}

function receiveZedlines(json) {
  return {
    type: RECEIVE_ZEDLINES,
    zedlines: json,
    receivedAt: Date.now()
  }
}

function fetchZedlines() {
  return dispatch => {
    dispatch(requestZedlines())
    return fetch('//jeff.4zzz.org.au/api/zedlines?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveZedlines(json)))
  }
}

function shouldFetchZedlines(state) {
  const zedlines = state.zedlines
  if (zedlines.items.length === 0) {
    return true
  } else if (zedlines.isFetching) {
    return false
  } else {
    return zedlines.didInvalidate
  }
}

export function fetchZedlinesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchZedlines(getState())) {
      return dispatch(fetchZedlines())
    }
  }
}


export function invalidateSlides() {
  return {
    type: INVALIDATE_NEWS_SLIDES
  }
}

function requestSlides() {
  return {
    type: REQUEST_NEWS_SLIDES
  }
}

function receiveSlides(json) {
  return {
    type: RECEIVE_NEWS_SLIDES,
    slides: json,
    receivedAt: Date.now()
  }
}

function fetchSlides() {
  return dispatch => {
    dispatch(requestSlides())
    return fetch('//jeff.4zzz.org.au/api/news-slider?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveSlides(json)))
  }
}

function shouldFetchSlides(state) {
  const slides = state.newsSlides
  if (slides.items.length === 0) {
    return true
  } else if (slides.isFetching) {
    return false
  } else {
    return slides.didInvalidate
  }
}

export function fetchSlidesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchSlides(getState())) {
      return dispatch(fetchSlides())
    }
  }
}


export function invalidateStories(page) {
  return {
    type: INVALIDATE_STORIES,
    page: page
  }
}

function requestStories(page) {
  return {
    type: REQUEST_STORIES,
    page: page
  }
}

function receiveStories(json, page) {
  return {
    type: RECEIVE_STORIES,
    page: page,
    stories: json,
    receivedAt: Date.now()
  }
}

function fetchStories(page) {
  return dispatch => {
    dispatch(requestStories(page))
    return fetch('//jeff.4zzz.org.au/api/news?_format=json&page=' + page)
      .then(response => response.json())
      .then(json => {
				let live = json.filter(i => i['live_content'] === 'true');
				live.forEach((item, i) => {
					dispatch(fetchLiveStory(item.nid))
				});
				console.log(live)
				dispatch(receiveStories(json, page));
			})
  }
}

function shouldFetchStories(state, page) {
  //const stories = state.stories
  const stories = state.stories.pages[page]
  if (!stories) {
    return true
  } else if (stories.isFetching) {
    return false
  } else {
    return stories.didInvalidate
  }
}

export function fetchStoriesIfNeeded(page) {
  return (dispatch, getState) => {
    if (shouldFetchStories(getState(), page)) {
      return dispatch(fetchStories(page))
    }
  }
}

export function resetActiveStory() {
  return {
    type: RESET_ACTIVE_STORY,
  }
}

function requestLiveStory(id) {
  return {
    type: REQUEST_LIVE_STORY,
    id: id
  }
}

function receiveLiveStory(json, id) {
  return {
    type: RECEIVE_LIVE_STORY,
    id: id,
    story: json,
    receivedAt: Date.now()
  }
}

function requestStory(id) {
  return {
    type: REQUEST_STORY,
    id: id
  }
}

function receiveStory(json, id) {
  return {
    type: RECEIVE_STORY,
    id: id,
    story: json,
    receivedAt: Date.now()
  }
}

function fetchStory(id) {
  return dispatch => {
    dispatch(requestStory(id))
    return fetch('//jeff.4zzz.org.au/news/' + id + '?_format=json')
      .then(response => response.json())
      .then(json => { 
        dispatch(receiveStory(json, id))
        if(json.uid && json.uid.length)
          dispatch( fetchAuthorIfNeeded(json.uid[0].target_id))
      })
  }
}


function fetchLiveStory(id) {
  return dispatch => {
    dispatch(requestLiveStory(id))
    return fetch('//jeff.4zzz.org.au/api/news-live/' + id + '?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveLiveStory(json, id)))
  }
}

function shouldFetchStory(state, id) {
  //const stories = state.stories
  const story = state.stories.articles[id]
  if (!story) {
    return true
  } else if (story.isFetching) {
    return false
  } else {
    return story.didInvalidate
  }
}

export function fetchStoryIfNeeded(id) {
  return (dispatch, getState) => {
    if (shouldFetchStory(getState(), id)) {
      return dispatch(fetchStory(id))
    }
  }
}


function requestAuthor(id) {
  return {
    type: REQUEST_AUTHOR,
    id: id
  }
}

function receiveAuthor(json, id) {
  return {
    type: RECEIVE_AUTHOR,
    id: id,
    author: json,
    receivedAt: Date.now()
  }
}

function fetchAuthor(id) {
  return dispatch => {
    dispatch(requestAuthor(id))
    return fetch('//jeff.4zzz.org.au/api/user/' + id + '?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveAuthor(json, id)))
  }
}

function shouldFetchAuthor(state, id) {
  //const stories = state.stories
  const author = state.stories.authors[id]
  if (!author) {
    return true
  } else if (author.isFetching) {
    return false
  } else {
    return author.didInvalidate
  }
}

function fetchAuthorIfNeeded(id) {
  return (dispatch, getState) => {
    if (shouldFetchAuthor(getState(), id)) {
      return dispatch(fetchAuthor(id))
    }
  }
}
